(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["orecelia-personalizer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('orecelia-personalizer')) {
    customElements.define('orecelia-personalizer', class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.init());
      }

      init() {
        if (!this.isConnected || this.launcher) return;

        this.section = this.closest('product-info');
        this.dialog = this.querySelector('dialog');

        if (!this.section || !this.dialog?.showModal) return;

        const native = this.nativeButton();
        const picker = this.section.querySelector('variant-selects');
        const engraving = this.section.querySelector('#orecelia-engraving');

        if (!native || !picker || !engraving || !native.form) return;

        this.form = native.form;
        this.moves = [];
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };

        this.move(picker, '[data-orc-options-slot]');
        this.move(engraving, '[data-orc-engraving-slot]');

        this.launcher = document.createElement('button');
        this.launcher.type = 'button';
        this.launcher.id = 'OrcPersonalize-' + this.dataset.sectionId;
        this.launcher.className =
          'button button--primary button--full-width';
        this.launcher.innerHTML = '<span>PERSONALIZE IT</span>';
        this.launcher.setAttribute('aria-haspopup', 'dialog');
        native.before(this.launcher);

        this.nativeDisplay = native.style.display;
        native.style.display = 'none';

        this.payment = this.section.querySelector('.shopify-payment-button');
        if (this.payment) {
          this.paymentDisplay = this.payment.style.display;
          this.payment.style.display = 'none';
        }

        this.launcher.addEventListener('click', () => this.open(), options);

        this.querySelector('[data-orc-close]').addEventListener(
          'click', () => this.dialog.close(), options
        );

        this.querySelector('[data-orc-review]').addEventListener(
          'click', () => {
            if (!this.refresh()) return;
            this.showStep(2);
          }, options
        );

        ['[data-orc-back]', '[data-orc-edit]'].forEach(selector => {
          this.querySelector(selector).addEventListener(
            'click', () => this.showStep(1), options
          );
        });

        this.querySelector('[data-orc-add]').addEventListener(
          'click', () => this.add(), options
        );

        this.dialog.addEventListener('input', () => this.refresh(), options);
        this.dialog.addEventListener('change', () => {
          this.showStep(1, false);
          this.refresh();
        }, options);

        this.dialog.addEventListener('close', () => {
          clearInterval(this.timer);
          this.timer = null;
          document.documentElement.style.overflow = this.previousOverflow;
          if (this.launcher?.isConnected) this.launcher.focus();
        }, options);
      }

      nativeButton() {
        return document.getElementById(
          'ProductSubmitButton-' + this.dataset.sectionId
        );
      }

      move(node, selector) {
        const marker = document.createComment('Orecelia original position');
        node.before(marker);
        this.moves.push({ marker, selector });
        this.querySelector(selector).appendChild(node);
      }

      setText(selector, value) {
        const node = this.querySelector(selector);
        if (node && node.textContent !== value) node.textContent = value;
      }

      getState() {
        const picker = this.section.querySelector('variant-selects');
        const field = this.section.querySelector('#orecelia-engraving-text');
        const native = this.nativeButton();
        const quantityInput = this.section.querySelector('.quantity__input');
        const quantity = Number(quantityInput?.value || 1);

        let variant = null;
        try {
          variant = JSON.parse(
            picker?.querySelector('[data-selected-variant]')?.textContent || 'null'
          );
        } catch (_) {}

        const selected = picker
          ? Array.from(picker.querySelectorAll('fieldset, select'))
              .map(element => element.tagName === 'SELECT'
                ? element.value
                : element.querySelector('input:checked')?.value)
              .filter(value => value !== undefined)
          : [];

        const settled = variant && selected.length === variant.options.length &&
          selected.every((value, index) => value === variant.options[index]);

        const custom = selected.some(value => value.includes('Customized'));
        const text = field?.value.trim() || '';

        const quantityValid = Number.isInteger(quantity) && quantity > 0 &&
          (!quantityInput || quantityInput.checkValidity());

        const available = settled && variant.available && native &&
          !native.disabled &&
          native.getAttribute('aria-disabled') !== 'true' &&
          !native.classList.contains('loading') &&
          !this.form.querySelector('[name="id"]')?.disabled;

        const currency = picker?.dataset.currencyCode ||
          window.Shopify?.currency?.active;

        let total = '';
        if (settled && currency && quantityValid) {
          try {
            total = new Intl.NumberFormat(
              document.documentElement.lang || 'en',
              { style: 'currency', currency, currencyDisplay: 'code' }
            ).format(variant.price * quantity / 100);
          } catch (_) {}
        }

        return {
          field, variant, selected, settled, custom, text,
          quantity, quantityValid, available, total,
          valid: !!(
            available && quantityValid && total &&
            (!custom || (text.length > 0 && text.length <= 10))
          )
        };
      }

      refresh() {
        const state = this.getState();

        this.setText(
          '[data-orc-price]',
          state.total ? 'Total: ' + state.total : 'Updating…'
        );
        this.setText('[data-orc-total]', state.total);
        this.setText('[data-orc-front-summary]', state.selected[0] || '');
        this.setText(
          '[data-orc-back-summary]',
          state.custom ? state.text : 'None'
        );
        this.setText('[data-orc-quantity-summary]', String(state.quantity));

        this.querySelector('[data-orc-review]').disabled = !state.valid;
        this.querySelector('[data-orc-add]').disabled = !state.valid;

        this.setText(
          '[data-orc-add]',
          state.total ? 'Add to cart · ' + state.total : 'Add to cart'
        );

        let message = '';
        if (!state.settled) {
          message = 'Updating your selection…';
        } else if (!state.available) {
          message = 'This selection is currently unavailable or updating.';
        } else if (!state.quantityValid) {
          message = 'Please close this window and check the quantity.';
        } else if (state.custom && !state.text) {
          message = 'Please enter your back engraving text.';
        } else if (state.custom && state.text.length > 10) {
          message = 'Maximum 10 characters, including spaces.';
        }

        this.setText('[data-orc-error]', message);
        this.querySelector('[data-orc-error]').hidden = !message;

        return state.valid;
      }

      showStep(step, focus = true) {
        this.querySelector('[data-orc-entry]').hidden = step !== 1;
        this.querySelector('[data-orc-summary]').hidden = step !== 2;

        this.setText(
          '[data-orc-step-label]',
          step === 1 ? 'STEP 1 OF 2' : 'STEP 2 OF 2'
        );

        this.setText(
          '.orc-personalizer__title',
          step === 1 ? 'Your personalization' : 'Check your personalization'
        );

        const bars = this.querySelectorAll('.orc-personalizer__progress span');
        bars.forEach((bar, index) => {
          bar.classList.toggle('is-active', index < step);
        });

        if (focus) {
          this.dialog.scrollTop = 0;
          this.querySelector('.orc-personalizer__title').focus();
        }
      }

      open() {
        if (this.dialog.open) return;

        this.showStep(1, false);
        this.refresh();

        this.previousOverflow = document.documentElement.style.overflow;
        this.dialog.showModal();
        document.documentElement.style.overflow = 'hidden';

        this.querySelector('.orc-personalizer__title').focus();
        this.timer = setInterval(() => this.refresh(), 200);
      }

      add() {
        if (!this.refresh()) {
          this.showStep(1);
          return;
        }

        const state = this.getState();
        const native = this.nativeButton();

        let property = this.form.querySelector(
          'input[name="properties[Back engraving text]"]'
        );

        if (!property) {
          property = document.createElement('input');
          property.type = 'hidden';
          property.name = 'properties[Back engraving text]';
          property.setAttribute('data-orc-engraving', '1');
          this.form.appendChild(property);
        }

        property.value = state.text;
        property.disabled = !state.custom;

        if (state.field) {
          state.field.dispatchEvent(new Event('input', { bubbles: true }));
        }

        this.querySelector('[data-orc-add]').disabled = true;
        this.dialog.close();

        // Keep Shopify's existing validation and cart submission.
        native.click();

        requestAnimationFrame(() => {
          const error = this.section.querySelector(
            '.product-form__error-message-wrapper:not([hidden])'
          );
          if (error) error.scrollIntoView({ block: 'center' });
        });
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        clearInterval(this.timer);

        if (this.dialog?.open) {
          this.dialog.close();
          document.documentElement.style.overflow = this.previousOverflow;
        }

        this.controller?.abort();

        (this.moves || []).forEach(({ marker, selector }) => {
          const node = this.querySelector(selector)?.firstElementChild;
          if (marker.isConnected && node) marker.replaceWith(node);
        });

        const native = this.nativeButton();
        if (native && this.nativeDisplay !== undefined) {
          native.style.display = this.nativeDisplay;
        }

        if (this.payment && this.paymentDisplay !== undefined) {
          this.payment.style.display = this.paymentDisplay;
        }

        this.launcher?.remove();
        this.launcher = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["orecelia-sticky-cart"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('orecelia-sticky-cart')) {
    customElements.define('orecelia-sticky-cart', class extends HTMLElement {
      connectedCallback() {
        this.bar = this.querySelector('.orc-cart-bar');
        if (!this.bar) return;

        this.section = this.closest('.shopify-section');
        this.button = this.bar.querySelector('button');
        this.mobile = window.matchMedia('(max-width: 749px)');
        document.body.appendChild(this.bar);

        this.original = () =>
  document.getElementById(
    'OrcPersonalize-' + this.dataset.sectionId
  ) ||
  document.getElementById(
    'ProductSubmitButton-' + this.dataset.sectionId
  );

        this.update = () => {
          const original = this.original();
          const busy = original && (
            original.disabled ||
            original.getAttribute('aria-disabled') === 'true' ||
            original.classList.contains('loading')
          );

          this.button.disabled = !original || busy;

          const label = original && original.querySelector('span');
          if (label) {
            this.button.textContent = label.textContent.trim();
          }

          const editing = document.activeElement &&
            document.activeElement.matches('input, textarea, select');

          const overlay = document.querySelector(
            'cart-drawer.active, cart-notification.active, dialog[open], ' +
            'details[open] .menu-drawer'
          );

          const visible = this.mobile.matches && original &&
            original.getClientRects().length > 0 &&
            original.getBoundingClientRect().bottom < 0 &&
            !editing && !overlay;

          this.bar.hidden = !visible;
          document.body.classList.toggle('orc-cart-visible', !!visible);
        };

        this.schedule = () => {
          if (this.frame) return;

          this.frame = requestAnimationFrame(() => {
            this.frame = null;
            this.update();
          });
        };

        this.button.addEventListener('click', () => {
          const original = this.original();

          if (!original || original.disabled ||
              original.getAttribute('aria-disabled') === 'true' ||
              original.classList.contains('loading')) return;

          original.click();
          this.update();

          const error = this.section &&
            this.section.querySelector(
              '.product-form__error-message-wrapper:not([hidden])'
            );

          if (error) {
            error.scrollIntoView({ block: 'center' });
          }
        });

        this.events = ['scroll', 'resize', 'focusin', 'focusout', 'change'];

        this.events.forEach(name =>
          window.addEventListener(name, this.schedule, { passive: true })
        );

        this.observer = new MutationObserver(() => {
          this.schedule();

          const error = this.section &&
            this.section.querySelector(
              '.product-form__error-message-wrapper:not([hidden])'
            );

          if (error && !this.bar.hidden) {
            error.scrollIntoView({ block: 'center' });
          }
        });

        if (this.section) {
          this.observer.observe(this.section, {
            subtree: true,
            childList: true,
            attributes: true,
            characterData: true
          });
        }

        document.querySelectorAll('cart-drawer, cart-notification')
          .forEach(el =>
            this.observer.observe(el, { attributes: true })
          );

        this.schedule();
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();

        if (this.events) {
          this.events.forEach(name =>
            window.removeEventListener(name, this.schedule)
          );
        }

        cancelAnimationFrame(this.frame);

        if (this.bar) this.bar.remove();

        document.body.classList.remove('orc-cart-visible');
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
